<template>
  <div class="massLoss-list">
    <div class="nav">
      <el-form :model="searchForm" label-width="140px" :inline="true" class="demo-form-inline flex1">
        <el-form-item label="年月起止时间：">
          <!--          <el-input v-model='searchForm.years' size='mini' placeholder='请输入年月'/>-->
          <el-date-picker v-model="searchForm.settlementStartYears" size="mini" style="width: 150px" value-format="yyyyMM" @change="dateChange" type="month" placeholder="开始日期" />
          <span style="display: inline-block; width: 15px; text-align: center; font-size: 18px">-</span>
          <el-date-picker v-model="searchForm.settlementEndYears" size="mini" style="width: 150px" value-format="yyyyMM" @change="dateChange" type="month" placeholder="结束日期" />
        </el-form-item>
        <el-form-item label="业务单位：">
          <el-input v-model="searchForm.businessUnit" size="mini" placeholder="请输入业务单位" />
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <el-button size="small" class="searchBtn" @click="LockOrUnlock">锁定/解锁</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span="24" style="text-align: end; font-size: 14px !important" class="exportButton">
        <span @click="exportData">导出数据</span>
      </el-col>
    </el-row>
    <div class="content">
      <div class="tableContainer">
        <el-table ref="registerTable" row-key="id" v-loading="tableLoading" :data="tableData" style="width: 100%" border :max-height="tableMaxHeight" :header-cell-style="headerCellStyle" @select="handleCurrentChange" @select-all="handleCurrentChange" :span-method="objectSpanMethod" :row-style="rowStyle">
          <el-table-column type="selection" align="center" width="50px" :reserve-selection="true" />
          <el-table-column prop="years" label="年月" align="center" />
          <el-table-column prop="type" label="项目（数量、计量单位）" align="center" width="180" />
          <el-table-column label="业务量情况" align="center">
            <el-table-column prop="transport2" label="非多式联运" align="center" width="100" />
            <el-table-column prop="transport" label="多式联运" align="center" width="80" />
          </el-table-column>
          <el-table-column label="运营情况" align="center">
            <el-table-column prop="value" label="营业收入（不含税-万元）" align="center" width="180" />
            <el-table-column prop="netProfit" label="净利润（万元）" align="center" width="120" />
            <el-table-column prop="personnelNumber" label="期末员工数（人）" align="center" width="140" />
            <el-table-column label="实体单位填报" align="center">
              <el-table-column prop="weight" label="重量（吨）" align="center" width="160" />
              <el-table-column prop="turnover" label="运输周转量（吨公里）" align="center" width="160" />
              <el-table-column prop="distance" label="运输周里程（公里）" align="center" width="140" />
              <el-table-column prop="meteringCompany" label="能耗种类、数量、计量单位（吨、立方、度等）" align="center" width="300" />
            </el-table-column>
          </el-table-column>
          <el-table-column prop="businessUnit" label="业务单位" align="center" width="180" />
          <el-table-column prop="submitter" label="提交人" align="center" width="140" />
          <el-table-column prop="submitTime" label="提交时间" align="center" width="160" />
          <!-- <el-table-column prop='operatePerson' label='操作人' align='center' width='140' /> -->
          <!-- <el-table-column prop='operateTime' label='操作时间' align='center' width='160' /> -->
          <!-- <el-table-column prop='lockOrUnlockPerson' label='锁定/解锁人' align='center' width='140' /> -->
          <!-- <el-table-column prop='lockOrUnlockTime' label='锁定/解锁时间' align='center' width='160' /> -->
          <el-table-column label="锁定状态" align="center">
            <template slot-scope="scope">
              {{ scope.row.lockingType ? '锁定' : '未锁定' }}
            </template>
          </el-table-column>
          <el-table-column label="退回状态" align="center">
            <template slot-scope="scope">
              {{ scope.row.returnType ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="280px" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" :loading="infoLoading" @click="btnClick('info', scope.row)">详情 </el-button>
              <el-button size="mini" type="primary" @click="btnClick(scope.row.netProfit !== '' ? 'edit' : 'add', scope.row)">
                {{ scope.row.netProfit !== '' ? '编辑' : '添加' }}
              </el-button>
              <el-button v-if="scope.row.returnType === 0" size="mini" type="warning" @click="btnClick('back', scope.row)">退回 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" :current-page.sync="searchForm.page" :page-size="searchForm.rows" />
      </div>
    </div>

    <!-- 修改 -->
    <year-and-month-summary-form ref="yearAndMonthSummaryFormRef" @searchBtn="searchBtn" />
    <!-- 详情 -->
    <year-and-month-summary-info ref="yearAndMonthSummaryInfoRef" @infoLoading="infoLoadingChange" />
  </div>
</template>

<script>
  import { monthlySummaryLocking, monthlySummaryPage, monthlySummaryReturnData } from '@/service/financial';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import YearAndMonthSummaryForm from './components/yearAndMonthSummaryForm.vue';
  import YearAndMonthSummaryInfo from './components/yearAndMonthSummaryInfo.vue';

  export default {
    name: 'yearAndMonthSummary',
    components: {
      YearAndMonthSummaryForm,
      YearAndMonthSummaryInfo,
    },
    data() {
      return {
        searchForm: {
          settlementStartYears: '',
          settlementEndYears: '',
          businessUnit: '',
          page: 1,
          rows: 10,
        },
        defaultSearchForm: {},
        tableLoading: false,
        infoLoading: false,
        tableData: [],
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        total: 0,
        checkTableData: [],
        windowHeight: 0,
        tableMaxHeight: 650,
      };
    },
    watch: {
      windowHeight() {
        this.getResolution(true);
      },
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      // this.searchBtn();
      this.getResolution();
    },
    methods: {
      getResolution(flag) {
        if (flag) {
          this.windowHeight === 1080 ? (this.tableMaxHeight = 650) : (this.tableMaxHeight = 380);
          this.$forceUpdate();
          return;
        }
        this.windowHeight = window.screen.height;
      },
      async btnClick(str, row) {
        switch (str) {
          case 'add':
            await this.$refs.yearAndMonthSummaryFormRef.dialogOpen('新增', row);
            break;
          case 'edit':
            await this.$refs.yearAndMonthSummaryFormRef.dialogOpen('编辑', row);
            break;
          case 'info':
            this.infoLoading = true;
            await this.$refs.yearAndMonthSummaryInfoRef.dialogOpen(row.id);
            break;
          case 'back':
            const { status, message } = await monthlySummaryReturnData({ id: row.id });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            await this.getTableData();
            break;
        }
      },
      infoLoadingChange() {
        this.infoLoading = false;
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/monthly/summary/exportData?access_token=${token}&years=${this.searchForm.years}&businessUnit=${this.searchForm.businessUnit}`;
        window.exportExcelGet('/platform/monthly/summary/exportData', `years=${this.searchForm.years}&businessUnit=${this.searchForm.businessUnit}`)
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const { status, message, data } = await monthlySummaryPage(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      // 多选事件触发
      handleCurrentChange(val) {
        this.checkTableData = val;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      // 锁定/解锁
      async LockOrUnlock() {
        if (this.checkTableData.length === 0) return this.$message.warning('请选择数据后锁定/解锁');
        const ids = [];
        this.checkTableData.forEach(item => {
          ids.push(item.id);
        });
        const { status, message } = await monthlySummaryLocking({ ids: ids });
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        this.clearCheckTableData();
      },
      clearCheckTableData() {
        this.$refs.registerTable.clearSelection();
        this.checkTableData = [];
        this.getTableData();
      },
      // 合并相同列
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        // data ：需要修改的列数和列的属性 第一列从0开始
        const data = [
          {
            columnIndex: 0,
            value: 'id',
          },
          {
            columnIndex: 1,
            value: 'years',
          },
          // {
          //   columnIndex: 6,
          // },
          {
            columnIndex: 7,
            value: 'personnelNumber',
          },
          // {
          //   columnIndex: 8,
          // },
          // {
          //   columnIndex: 9,
          // },
          // {
          //   columnIndex: 10,
          // },
          // {
          //   columnIndex: 11,
          // },
          // {
          //   columnIndex: 12,
          // },
          // {
          //   columnIndex: 13,
          // },
          // {
          //   columnIndex: 14,
          // },
          // {
          //   columnIndex: 15,
          // },
          // {
          //   columnIndex: 16,
          // },
        ];
        for (let index = 0; index < data.length; index++) {
          if (columnIndex === data[index].columnIndex) {
            const _row = this.filterData(this.tableData, data[index].value)[rowIndex];
            const _col = _row > 0 ? 1 : 0;
            return {
              rowspan: _row,
              colspan: _col,
            };
          }
        }
      },
      // 根据是否有相同数据返回一个如[2,0,3,0,0]格式的数组(公共的)
      filterData(arr, value) {
        let spanOneArr = [];
        let concatOne = 0;
        arr.forEach((item, index) => {
          if (index === 0) {
            spanOneArr.push(1);
          } else {
            // name 修改
            if (item[value] === arr[index - 1][value]) {
              spanOneArr[concatOne] += 1;
              spanOneArr.push(0);
            } else {
              spanOneArr.push(1);
              concatOne = index;
            }
          }
        });
        return spanOneArr;
      },
      // 结束时间
      dateChange(val) {
        if (this.searchForm.settlementEndYears && this.searchForm.settlementStartYears && this.searchForm.settlementEndYears <= this.searchForm.settlementStartYears) {
          if (val === this.searchForm.settlementEndYears) this.searchForm.settlementEndYears = '';
          if (val === this.searchForm.settlementStartYears) this.searchForm.settlementStartYears = '';
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .massLoss-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;

    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }

    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }
            }
          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #ffffff;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }
    }
  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      margin-right: 10px;
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
